import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { useOnClickOutside } from 'utils/helpers';
import './ButtonDropdown.scss';
import useDropdownPosition from 'hooks/useDropdownPosition';

const ButtonDropdown = ({
  buttonElement,
  isDropdownBlocked,
  children,
  dropdownPosition,
  isFixedHeight,
  isFullHeight,
  isFullWidth,
  isItemsEmpty,
  onCloseDropdown,
  withAbsolutePosition,
  buttonElementRect,
  dropDownCloseStatus,
  customContainerClass,
  isSmallHeight,
  isDropdownInModal,
}) => {
  const ref = useRef();

  const {
    dropdownIsOpen,
    dropdownVerticalPosition,
    showdropdown,
    setDropdownIsOpen,
  } = useDropdownPosition(false, ref);

  useEffect(() => {
    setDropdownIsOpen(dropDownCloseStatus);
  }, [dropDownCloseStatus]);

  useOnClickOutside(ref, () => {
    setDropdownIsOpen(false);
    onCloseDropdown?.(false);
  });

  const buttonDropdownStyles = classNames({
    'ButtonDropdownNotifContainer': true,
    'ButtonDropdownNotifContainerLeft': dropdownPosition === 'left',
    'ButtonDropdownNotifContainerRight': dropdownPosition === 'right',
    'ButtonDropdownNotifContainerFixedHeight': isFixedHeight,
    'ButtonDropdownNotifContainerFullHeight': isFullHeight,
    'ButtonDropdownNotifContainerModalDropdown': isDropdownInModal,
    'ButtonDropdownNotifContainerFullWidth': isFullWidth,
    'ButtonDropdownNotifContainerEmpty': isItemsEmpty,
    'ButtonDropdownNotifContainerTop': dropdownVerticalPosition === 'top',
    'ButtonDropdownNotifContainerBottom': dropdownVerticalPosition === 'bottom',
    'ButtonDropdownNotifContainerSmallHeight': isSmallHeight,
    [customContainerClass]: !!customContainerClass,
  });

  const absolutePositionStyles = withAbsolutePosition ? {
    position: 'absolute',
    top: dropdownVerticalPosition === 'top' ? 'unset' : '64px',
    bottom: dropdownVerticalPosition === 'bottom' ? 'unset' : '64px',
    width: buttonElementRect ? buttonElementRect.width : 'unset'
  } : {};

  return (
    <div
      ref={ref}
      className={classNames({
        'ButtonDropdownContainer': true,
        'ButtonDropdownContainerCenter': dropdownPosition === 'center',
      })}
    >
      <div
        className="ButtonDropdownButtonWrapper"
        onClick={showdropdown}
      >
        {buttonElement}
      </div>

      {dropdownIsOpen && !isDropdownBlocked && (
        <div
          className={buttonDropdownStyles}
          style={absolutePositionStyles}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default ButtonDropdown;